import React from 'react';

import { useLanguage } from '../i18n';

const tints = ['bg-ronda-soft', 'bg-peach/35', 'bg-straw/30', 'bg-scooter/10'];

const Steps = () => {
  const { steps, stepsSection } = useLanguage().t;

  return (
    <section id='how-it-works' className='py-20 lg:py-28'>
      <div className='container'>
        <div className='max-w-[640px]'>
          <p className='eyebrow'>{stepsSection.eyebrow}</p>
          <h2 className='title mt-4'>{stepsSection.title}</h2>
          <p className='lead mt-5'>{stepsSection.text}</p>
        </div>

        <ol className='mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
          {steps.map((step, index) => (
            <li
              key={index}
              className='flex flex-col rounded-card border border-line bg-paper p-3'
            >
              <div
                className={`flex h-44 items-center justify-center rounded-[22px] ${tints[index]}`}
              >
                <img
                  src={step.image}
                  alt=''
                  loading='lazy'
                  className='max-h-[132px] w-auto max-w-[78%] object-contain'
                />
              </div>
              <div className='px-3 pb-4 pt-6'>
                <h3 className='text-[22px] tracking-title'>{step.title}</h3>
                <p className='mt-2 leading-relaxed text-muted'>{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Steps;
